<template>
  <div class="container">
    <ul v-if="detail != '' && detailVal != undefined">
      <li>
        <label>创建日期：</label>
        <p>{{ detailVal.create_time }}</p>
      </li>
      <li>
        <label>盘点单号：</label>
        <p>{{ detailVal.no }}</p>
      </li>
      <li>
        <label>操作人：</label>
        <p>{{ detailVal.user_name }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>商品名称</th>
        <th>商品图</th>
        <th>类型</th>
        <th>盘点前库存</th>
        <th>盘点后库存</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in detail" :key="index">
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>
            <p v-show="item.num_type == 0">不变</p>
            <p v-show="item.num_type == 1">增加</p>
            <p v-show="item.num_type == 2">减少</p>
          </td>
          <td>{{ item.old_num }}</td>
          <td>{{ item.now_num }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_check/getProjectCheckDetail";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_check_id: this.detailVal.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.detail = res.data.data;
          //   console.log(this.detail);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
}
</style>
